import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const year = new Date().getFullYear();
  return <footer className="border-t border-white/5 bg-slate-950 py-12 px-4" data-id="element-21">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center gap-6" data-id="element-22">
        <div className="bg-white rounded-xl px-5 py-3 shadow-sm" data-id="element-23">
          <img src="https://cdn.magicpatterns.com/uploads/exH9G2rgUuiMQFMLYuFBer/Captura_de_pantalla_2026-06-11_a_la(s)_11.21.26_a.m..png" alt="MinHealthGroup" className="h-10 w-auto object-contain" data-id="element-24" />
        </div>

        <nav aria-label="Enlaces legales" className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3" data-id="element-25">
          <button onClick={() => setActiveModal('privacy')} className="text-sm text-slate-400 hover:text-amber-400 transition-colors focus:outline-none focus:text-amber-400" data-id="element-26">
            Política de Privacidad
          </button>
          <span className="text-slate-700" aria-hidden="true" data-id="element-27">
            ·
          </span>
          <button onClick={() => setActiveModal('terms')} className="text-sm text-slate-400 hover:text-amber-400 transition-colors focus:outline-none focus:text-amber-400" data-id="element-28">
            Términos y Condiciones
          </button>
        </nav>

        <p className="text-sm text-slate-600" data-id="element-29">
          © {year} MinHealthGroup. Todos los derechos reservados.
        </p>

        <p className="text-xs text-slate-700 max-w-xl leading-relaxed" data-id="element-30">
          Este producto es de carácter educativo y no constituye asesoramiento
          médico. Los resultados pueden variar según cada persona.
        </p>
      </div>

      {/* Privacy Modal */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" lastUpdated="12 de junio de 2026" data-id="element-31">
        <p data-id="element-32">
          En MinHealthGroup respetamos tu privacidad. Esta política describe
          cómo recopilamos, utilizamos y protegemos la información que nos
          proporcionas al utilizar nuestro sitio y adquirir nuestros productos.
        </p>
        <div data-id="element-33">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-34">
            1. Información que recopilamos
          </h3>
          <p data-id="element-35">
            Podemos recopilar datos que nos facilitas voluntariamente, como tu
            nombre y correo electrónico al realizar una compra, así como datos
            de navegación recogidos automáticamente (dirección IP, tipo de
            navegador y páginas visitadas).
          </p>
        </div>
        <div data-id="element-36">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-37">
            2. Uso de la información
          </h3>
          <p data-id="element-38">
            Utilizamos tus datos para procesar pedidos, entregar el acceso al
            producto digital, mejorar nuestros servicios y enviarte
            comunicaciones relacionadas con tu compra. Nunca venderemos tu
            información a terceros.
          </p>
        </div>
        <div data-id="element-39">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-40">3. Cookies</h3>
          <p data-id="element-41">
            Empleamos cookies y tecnologías similares para recordar tus
            preferencias y analizar el tráfico del sitio. Puedes configurar tu
            navegador para rechazar las cookies, aunque esto podría afectar a
            algunas funcionalidades.
          </p>
        </div>
        <div data-id="element-42">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-43">
            4. Seguridad de los datos
          </h3>
          <p data-id="element-44">
            Aplicamos medidas técnicas y organizativas razonables para proteger
            tu información frente a accesos no autorizados, pérdida o
            alteración.
          </p>
        </div>
        <div data-id="element-45">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-46">
            5. Tus derechos
          </h3>
          <p data-id="element-47">
            Tienes derecho a acceder, rectificar o solicitar la eliminación de
            tus datos personales, así como a oponerte a su tratamiento, conforme
            a la legislación vigente en materia de protección de datos.
          </p>
        </div>
        <div data-id="element-48">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-49">
            6. Cambios en esta política
          </h3>
          <p data-id="element-50">
            Nos reservamos el derecho de actualizar esta política en cualquier
            momento. Las modificaciones se publicarán en esta misma página con
            su fecha de actualización.
          </p>
        </div>
      </LegalModal>

      {/* Terms Modal */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" lastUpdated="12 de junio de 2026" data-id="element-51">
        <p data-id="element-52">
          Al acceder y utilizar este sitio web y adquirir El Protocolo de
          Longevidad 45+, aceptas los siguientes términos y condiciones en su
          totalidad.
        </p>
        <div data-id="element-53">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-54">
            1. Aceptación de los términos
          </h3>
          <p data-id="element-55">
            El uso de este sitio implica la aceptación plena de estos términos.
            Si no estás de acuerdo con alguno de ellos, te pedimos que no
            utilices el sitio ni adquieras el producto.
          </p>
        </div>
        <div data-id="element-56">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-57">
            2. Uso del producto
          </h3>
          <p data-id="element-58">
            El producto se proporciona en formato digital para uso personal y no
            transferible. Queda prohibida su reproducción, distribución o
            reventa sin autorización expresa.
          </p>
        </div>
        <div data-id="element-59">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-60">
            3. Propiedad intelectual
          </h3>
          <p data-id="element-61">
            Todo el contenido, marcas, textos e imágenes son propiedad de
            MinHealthGroup y están protegidos por las leyes de propiedad
            intelectual aplicables.
          </p>
        </div>
        <div data-id="element-62">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-63">
            4. Descargo de responsabilidad sobre la salud
          </h3>
          <p data-id="element-64">
            La información ofrecida tiene fines exclusivamente educativos y no
            sustituye el consejo, diagnóstico ni tratamiento médico profesional.
            Los resultados pueden variar y no se garantizan. Consulta siempre a
            un profesional de la salud antes de iniciar cualquier protocolo,
            dieta o cambio de hábitos.
          </p>
        </div>
        <div data-id="element-65">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-66">
            5. Limitación de responsabilidad
          </h3>
          <p data-id="element-67">
            MinHealthGroup no será responsable de daños directos o indirectos
            derivados del uso o la imposibilidad de uso del producto o del sitio
            web.
          </p>
        </div>
        <div data-id="element-68">
          <h3 className="text-lg font-semibold text-white mb-2" data-id="element-69">
            6. Ley aplicable
          </h3>
          <p data-id="element-70">
            Estos términos se rigen por la legislación aplicable en la
            jurisdicción donde opera MinHealthGroup. Cualquier controversia se
            someterá a los tribunales competentes de dicha jurisdicción.
          </p>
        </div>
      </LegalModal>
    </footer>;
}